/**
 * Created by SH: 20/02/2020
 */

import {  gsap } from "gsap";
import { ReelState } from "../../dev/reel/ReelEngineView";
import { RoadRageEngineView } from "./RoadRageEngineView";
import { RoadRageSpriteSymbol } from "./symbol/RoadRageSpriteSymbol";
import { Helper } from "../../dev/utils/Helper";
import { RoadRage } from "../RoadRage";
import { GameConfig } from "../config/base/GameConfig";
import { ReelStopCallbacks } from "../../dev/reel/IData/IReelData";
import { ReelSymbolStates } from "../../dev/reel/symbol/ReelSpriteSymbolArea";
import { GameSetting } from "../../dev/setting/GameSetting";
import { ReelBaseSymbol } from "../../dev/reel/symbol/ReelBaseSymbol";
import { ArrayHelper } from "../../dev/utils/ArrayHelper";
import { BasicSymbolType } from "../../dev/reel/symbol/config/IReelSymbolStruct";
import { ReelGameData } from '../server/data/GameDataModels';
import { RoadRageEngineManager } from './RoadRageEngineManager';
import { SpinePlayer } from '../../dev/displayobject/SpinePlayer';

export class RoadRageEngineController extends RoadRageEngineView {

    private attentionTL: gsap.core.Timeline;
    private debugFeatureType: string = "AddMult+1";

    private goingToChangeLayout: boolean = false;
    private changedPosLayout: boolean = false;
    private scatterPlaced:boolean;

    public get AllSticky(): RoadRageSpriteSymbol[] { return this._stickyContainer.children as RoadRageSpriteSymbol[]; }

    public getSymbol(symbolID: number): RoadRageSpriteSymbol | undefined {
        // Fetching the Sticky first.
        const sticky: RoadRageSpriteSymbol | undefined = this.AllSticky.find((sym: RoadRageSpriteSymbol) => { return sym.posID.includes(symbolID) })
        if (sticky) return sticky;

        const sym: RoadRageSpriteSymbol | undefined = this.AllSymbols.find((sym: RoadRageSpriteSymbol) => { return sym.posID.includes(symbolID) })
        if (sym) return sym;

        return undefined;
    }

    public changeInteraction(type: string): void {
        this.debugFeatureType = type;
        this.applySymbolInteraction(true);
    }

    preferedSize(amount: number): number {
        switch (amount) {
            case 4: return 126;
            case 5: return 108;
            default: return 144;
        }
    }

    public attention(play: boolean): void {
        if (play) {
            this.attentionSpine.position = Helper.copyLocalPosition(this.attentionSpine,this);
            this.attentionSpine.y = ArrayHelper.fetchArrTypeValue(this.config.DIM.HEIGHT,this.reelID) - this.engine.stepDistance;

            this.attentionTL = Helper.setTimeline(this.attentionTL);
            this.attentionSpine.play({animation:"Reel_Attention",loop:true});
            this.attentionTL.fromTo(this.attentionSpine, { alpha: 0 }, { alpha: 1, duration: 0.25 });

        } else if (this.attentionSpine) {
            
            this.attentionTL = Helper.setTimeline(this.attentionTL, new gsap.core.Timeline({
                onComplete: () => {
                    this.attentionSpine.stop(false);
                }
            }));
            
            this.attentionTL.to(this.attentionSpine, { alpha: 0, duration: 0.25 });
        }
    }

    public switchToGlowPos(): void {
        this.AllWindowSymbols.forEach(s => { if(s.isCar) s.PlayGlowStop() });
    }

    public setupCarMovesIn(durr:number = 0.5): void {
        this.AllWindowSymbols.forEach(s => { if (s.isCar) s.carMovesIn(this.reelID === 4, durr) });
    }

    parseData(data: ReelGameData): void {
        super.parseData(data);
        this.setupMode = data.setupMode;
        this.laneSwitch = this.setupMode ? data.fsInfo.switchLane : [];

        this.scatterPlaced = data.reelsWithScatters[this.reelID];
    }

    onStarting(): void {
        super.onStarting();
    }

    onStopAnimationCompleted(): void {
        super.onStopAnimationCompleted();
    }

    protected setCurrentReelSet(name: string): void {
        // super.setCurrentReelSet(name);

        if(!this.config.REEL_SETS.get(name)) throw (`Missing reelset: " + ${name}`);
    
        if(this.scatterPlaced){
            this._currentReelSet = this.config.REEL_SETS.get(name)![this.reelID].filter(v => v !== "S")
        }else{
            this._currentReelSet = this.config.REEL_SETS.get(name)![this.reelID];
        }
    }

    public get layoutIsChanging(): boolean { return this.changedPosLayout; }

    protected addChildObjOrder(): void {
  
        this.addChild(this._animationContainer);

        this._graphArea = super.createGraphic(undefined, 1)
        this._graphArea.alpha = 0;
        this._graphArea.visible = false;

        this.addChild(this._stickyContainer);

        this.attentionSpine = RoadRage.overlayAnim.addChild(new SpinePlayer("Reel_FX",false))
       
        this.attentionSpine.zIndex = 200;

    }

    // protected setVisibleForOverflowSymbols(value: boolean): void {
    //     if (!this.isActive) return;
    //     this.mask = undefined!;
    //     for (let indx: number = 0; indx < this.AllSymbols.length; indx++) {
    //         const posID: number[] = this.AllSymbols[indx].posID;
    //         if (Math.max(...posID) < 0 || Math.min(...posID) >= this.windowConfAmount) this.AllSymbols[indx].setVisible(value);
    //     }
    // }

    public createStop(cb?: ReelStopCallbacks, attentionStop: boolean = false, extraStepDistance:number = 0): gsap.core.Timeline {
        this.stopCallbacks = cb ? cb : {};

        this.attentionStop = attentionStop;
        this.config.STOP_DISTANCE = extraStepDistance;
        if (!this.isQuickStop) {
            if (attentionStop)
                return this.createNextAnimation(() => this.engine.Stop(GameConfig.instance.REEL_ENGINE_CONFIG.DURATION.ATTENTION_STOP, GameConfig.instance.REEL_ENGINE_CONFIG.EASING.ATTENTION_STOP));
        }
        return this.createNextAnimation(() => this.engine.Stop(this.stopDuration, this.stopEase));
    }

    public setSticky(posID: number[]): void {
        
        posID.forEach(pos => {
            let sticky:RoadRageSpriteSymbol = this.AllSticky.filter(s => s.posID.indexOf(pos) >= 0)[0];
            if(sticky) sticky.remove();
            
            if (this.getSymbol(pos)) {
                this.getSymbol(pos)!.onSticky();
                this._stickyContainer.addChild(this.getSymbol(pos)!)
            };
        });
    }

    public mergeSticky(): void {
        if(this.AllSticky.length){
            this.AllSticky.forEach(child => {
                this.AllSymbols.find(s => s.posID[0] === (<RoadRageSpriteSymbol>child).posID[0])?.destroy();
            });
            this._animationContainer.addChild(...this.AllSticky);
        }
    }

    public applySymbolInteraction(interact: boolean): void {
        this.AllWindowSymbols.forEach(s => s.setInteractive(interact))
    }

    public replaceSymbol(sym: RoadRageSpriteSymbol): void {
        const symToReplace = this.getSymbol(sym.posID[0]);
        if (symToReplace) {
            sym.position = symToReplace.position;
            symToReplace.remove();
        }
        this.addSymbol(sym);
    }

    public addSymbolAbove(sym: RoadRageSpriteSymbol, remove:boolean = false): void {
        const symToReplace = this.getSymbol(sym.posID[0]);

        if (symToReplace) {
            sym.position = symToReplace.position;
            sym.zIndex = symToReplace.zIndex + 1;
        }

        if(remove) symToReplace?.remove();

        this.addSymbol(sym);
    }

    private reelSizeTL: gsap.core.Timeline;
    public ChangeReelAreaAndSymbol(amountOfSymbols: number, durr: number = 0.75): gsap.core.Timeline {
        const symSize: number = this.preferedSize(amountOfSymbols);
        this.reelSizeTL = Helper.setTimeline(this.reelSizeTL, undefined, true);

        if (this.engine.stepDistance == symSize && this.config.WINDOW_AMOUNT == amountOfSymbols) return this.reelSizeTL;

        this.engine.stepDistance = symSize;
        this.config.WINDOW_AMOUNT = amountOfSymbols;
        this.config.DIM.HEIGHT = amountOfSymbols * symSize;

        // const nextAreaSize: number = symSize * amountOfSymbols;

        // this.reelSizeTL.to(this.bgReelGfx,{height:nextAreaSize,duration:durr},0);
        // this.reelSizeTL.to(this.bgReelGfx.position,{y:(nextAreaSize-432)*(1/3),duration:durr},0);

        // this.reelSizeTL.to(this.position, { y: -(nextAreaSize - 432) * (1 / 6), duration: durr }, 0);
        this._graphArea.height = this.config.DIM.HEIGHT;
        this._graphArea.position.y = RoadRageEngineManager.movedOffsetY;

        durr = durr != undefined ? durr : GameConfig.instance.REEL_ENGINE_CONFIG.DURATION.EXPAND!;

        this.reelSizeTL.add(this.changeReelAmount(symSize,durr), 0)

        return this.reelSizeTL;
    }

    protected initReel(): void {
        this.setCurrentReelSet(this._nextReelSetName);

        let possAdded: number = 0;
        let symInitPos: number = this._stopReelSet.length;
        for (var i = -this.overflowAmount; i < (this.config.WINDOW_AMOUNT + this.overflowAmount); i++) {
            let symName: string = this._stopReelSet[symInitPos % this._stopReelSet.length];
            if (!symName || symName == BasicSymbolType.EMPTY) symName = "X";
            const symbol: ReelBaseSymbol = this.createNewSymbol(i, symName, undefined);

            if (i == -this.overflowAmount) {
                let overflowAmount: number = (symbol.symbolHeight - this.engine.stepDistance) * 0.5;
                possAdded = (symbol.symbolHeight * i) + overflowAmount;
                symbol.setPosID(-symbol.stackedValue);
                i += symbol.stackedValue - 1;
            } else {
                symbol.setPosID(ArrayHelper.fetchLastValue(this.AllSymbols[this.AllSymbols.length - 1].posID) + 1)
                possAdded += Math.abs(symbol.symbolHeight) * 0.5;
            }

            symbol.position = new PIXI.Point(0, possAdded);

            possAdded += (Math.abs(symbol.symbolHeight)) * 0.5;

            this.addSymbol(symbol);
            symInitPos++;
        }

        this.setVisibleForOverflowSymbols(false);
        this.addAndRemoveOutOfBound();
        this.sortChildren();

        this._hasInit = true;
    }

    protected onStep(movedDistance: number = this.engine.stepDistance): void {
        super.onStep(movedDistance);
        if (this.goingToChangeLayout) {

            this.goingToChangeLayout = false;

            this.AllSymbols.forEach((s, i) => {
                s.changeState({
                    state: this.state.isSpinning ? ReelSymbolStates.SPIN : ReelSymbolStates.NORMAL,
                    forceState: true,
                    sizeType: movedDistance,
                    duration: this.spinDuration,
                    ease: GameConfig.instance.REEL_ENGINE_CONFIG.EASING.EXPAND
                })
            })
            this.createNextAnimation(() => this.engine.ChangeSymPosStep(this.spinDuration));
            this.engine.activateNextAnimation();

        } else if (this.changedPosLayout) {
            this.createNextAnimation(() => this.engine.Step(this.spinDuration));
            this.engine.activateNextAnimation();

            this.changedPosLayout = false;
        }
    }

    restoreforcedSize(newSize: number, setupPhase:boolean = false): void {

        const symSize: number = this.preferedSize(newSize);

        this.engine.stepDistance = symSize;
        this.config.WINDOW_AMOUNT = newSize;
        this.config.DIM.HEIGHT = newSize * symSize;

        this._graphArea.height = this.config.DIM.HEIGHT;
        this._graphArea.position.y = RoadRageEngineManager.movedOffsetY;

        this.setupMode = setupPhase;

        this.removeAllSymbols();
        this.initReel();

    }

    public changeReelAmount(newSize: number,durr?:number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        this.engine.stepDistance = newSize;

        if (this.state.isSpinning) {
            this.changedPosLayout = true;
            this.goingToChangeLayout = true;
        } else {
            this.AllSymbols.forEach((s, i) => {
                tl.add(s.changeState({
                    state: this.state.isSpinning ? ReelSymbolStates.SPIN : ReelSymbolStates.NORMAL,
                    forceState: true,
                    sizeType: newSize,
                    duration: durr ? durr : this.spinDuration,
                    ease: GameConfig.instance.REEL_ENGINE_CONFIG.EASING.START
                }), 0);
            })
        }

        return tl;
    }

    public expandSymbol(posId: number, durr?: number, reset?: boolean): gsap.core.Timeline {
        const expansionTl: gsap.core.Timeline = Helper.setTimeline(new gsap.core.Timeline());
        durr = durr != undefined ? durr : GameConfig.instance.REEL_ENGINE_CONFIG.DURATION.EXPAND!;

        const sym: RoadRageSpriteSymbol | undefined = this.getSymbol(posId);
        this.engine.reverse = false;

        reset = sym?.sizeType.value > 7;

        let desiredSize: number = reset ? 1 : 2;

        if (sym) {
            this.createNextAnimation(() => this.engine.ExpandSymbol({
                duration: durr!,
                targetSym: posId,
                toSize: desiredSize,
                ease: GameConfig.instance.REEL_ENGINE_CONFIG.EASING.EXPAND,
            },
                this.AllWindowSymbols.length, this.AllWindowSymbols.length), ReelState.EXPAND_SYM);

            this.engine.activateNextAnimation();
            expansionTl.add(this.engine.activeTimeline!, 0);
        }

        this.AllWindowSymbols.forEach(sym => {
            let toSize: number = sym.posID[0] === posId ? 8 : 4;
            sym.changeState({
                state: ReelSymbolStates.NORMAL,
                sizeType: reset ? 7 : toSize,
                duration: durr,
                forceState: true,
                ease: GameConfig.instance.REEL_ENGINE_CONFIG.EASING.EXPAND
            });
        });

        return expansionTl;
    }
}
